export class RefreshFilterMessage {
    public isHandled: boolean = false;
}